var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3571 19.7143V18C19.3571 17.0907 18.9959 16.2186 18.3529 15.5756C17.71 14.9327 16.8379 14.5714 15.9286 14.5714H9.07142C8.16211 14.5714 7.29004 14.9327 6.64706 15.5756C6.00408 16.2186 5.64285 17.0907 5.64285 18V19.7143M15.9286 7.71428C15.9286 9.60783 14.3935 11.1429 12.5 11.1429C10.6064 11.1429 9.07142 9.60783 9.07142 7.71428C9.07142 5.82074 10.6064 4.28571 12.5 4.28571C14.3935 4.28571 15.9286 5.82074 15.9286 7.71428Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e48e9d017cf37c832b13b5aa24ebd2f6.svg";
export { ForwardRef as ReactComponent };